import { useTranslation } from 'react-i18next'
import { useLocation, useMatch, useParams } from 'react-router'

import Document from 'js/components/Document'
import AnimatedOutlet, {
    magazineTransitionDuration,
} from 'js/magazine-issue/View/Layout/AnimatedOutlet'
import { useMagazineView } from 'js/magazine-issue/View/MagazineViewContext'
import ThemeProvider from 'js/theme/ThemeProvider'

import { Header } from '../components/Header'

const Layout = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const params = useParams()
    const isAnimating = !!(location.state as { direction?: string })?.direction
    const { magazineIssue, articles } = useMagazineView()
    const articleGuid = params.guid

    const { url, backgroundColor, container, issueNumber } = magazineIssue

    const pathIsHome = !!useMatch({ path: url, end: true })
    const pathIsColophon = !!useMatch({ path: `${url}/colophon`, end: true })

    const currentArticle = articles.find((a) => a.guid === articleGuid) || null

    const themeColor = pathIsHome
        ? backgroundColor || articles[0]?.backgroundColor || '#FFFFFF'
        : currentArticle?.backgroundColor || backgroundColor || '#FFFFFF'

    return (
        <ThemeProvider
            theme={themeColor}
            bodyColor={themeColor}
            bodyTransitionDuration={
                isAnimating ? `${magazineTransitionDuration}s` : undefined
            }
        >
            <Document
                title={
                    pathIsHome
                        ? t('entity-magazine.cover-page')
                        : pathIsColophon
                          ? t('entity-magazine.colophon')
                          : currentArticle?.title
                }
                containerTitle={`${container.title} ${issueNumber}`}
            />

            <Header
                pathIsHome={pathIsHome}
                pathIsColophon={pathIsColophon}
                currentArticle={currentArticle}
                themeColor={themeColor}
            />

            <AnimatedOutlet />
        </ThemeProvider>
    )
}

export default Layout
